class IngredientsVideo extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.iframe = null;
    this.youtubePlayer = null;
  }

  connectedCallback() {
    this.video = this.querySelector('video');
    this.iframe = this.querySelector('iframe');
    const videoType = this.getAttribute('data-video-type');

    if (this.video) {
      this.video.addEventListener('click', () => {});
    }

    if (this.iframe && videoType === 'youtube') {
      this.initYouTubePlayer();
      this.iframe.addEventListener('click', () => {});
    }

    this.setupFactsLink();
  }

  initYouTubePlayer() {
    if (!window.YT) {
      const tag = document.createElement('script');
      // ✅ FIX 1: Changed to youtube-nocookie.com
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
      window.onYouTubeIframeAPIReady = () => {
        this.createYouTubePlayer();
      };
    } else if (window.YT && window.YT.Player) {
      this.createYouTubePlayer();
    }
  }

  createYouTubePlayer() {
    if (this.iframe && this.iframe.id) {
      // ✅ FIX 2: Added host parameter for nocookie
      this.youtubePlayer = new YT.Player(this.iframe.id, {
        host: 'https://www.youtube-nocookie.com'
      });
    }
  }

  setupFactsLink() {
    setTimeout(() => {
      const factsLink = document.querySelector('.ingredients__facts-link');
      if (factsLink) {
        factsLink.addEventListener('click', (e) => {
          e.preventDefault();
          const config = window.factsLinkConfig || { action: 'video_timestamp' };
          if (config.action === 'external_url' && config.externalUrl) {
            window.location.href = config.externalUrl;
          } else if (config.action === 'video_timestamp' && window.benefitsData) {
            const activeBenefit = document.querySelector('.ingredients__benefit--active');
            const buttons = document.querySelectorAll('.ingredients__benefit');
            const index = Array.from(buttons).indexOf(activeBenefit);
            const timestamp = window.benefitsData[index]?.timestamp || 0;
            this.skipTo(parseFloat(timestamp));
          }
        });
      }
    }, 500);
  }

  skipTo(seconds) {
    if (this.video) {
      this.video.currentTime = seconds;
      this.video.play();
    } else if (this.youtubePlayer && this.youtubePlayer.seekTo) {
      this.youtubePlayer.seekTo(seconds, true);
      this.youtubePlayer.playVideo();
    }
  }
}

customElements.define('ingredients-video', IngredientsVideo);